import {Component} from '@angular/core';
import {Contact} from "../../../Interfaces/contact.interface";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../../../services/loader/loader.service";
import {ActivatedRoute, Router} from "@angular/router";
import Helper from "../../../Helper/Helper";
import PermissionsHelper from "../../../Helper/PermissionsHelper";

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.css'
})
export class ContactsComponent {

  public contacts: Contact[] | undefined
  public showarchived: boolean = false;
  public apierror: boolean = false;
  public uuid: string | undefined

  constructor(private httpClient: HttpClient, protected loader: LoaderService, public router: Router, private route: ActivatedRoute) {
    this.loader.showLoader()
    this.route.params.subscribe(params => {
      this.uuid = params['uuid']
    });
    this.getContacts()
  }

  private getContacts(sortby: string = "", sorttype: string = "") {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }

    urlSearchParams.set("archived", String(this.showarchived));

    console.log(urlSearchParams.toString())

    this.httpClient.get<RestResponse<Contact[]>>(RestHelper.API_BASE_URL + "customer/getContact?uuid=" + this.uuid + "&" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
      next: (value) => {
        this.contacts = value.data
        this.loader.hideLoader()
      }, error: () => {
        this.apierror = true
        this.loader.hideLoader()
      }
    })
  }

  public changeShowArchivedStatus(event: Event) {
    const input = event.target as HTMLInputElement;
    this.showarchived = input.checked
    this.getContacts(this.lastsort, this.lastsorttype)
  }

  public remoteEntryFromTable(event: Event) {
    const input = event.target as HTMLInputElement;
    input.parentElement?.parentElement?.remove();
  }

  public saveContacts() {
    var tablebody = document.getElementById("table-values");
    const tablerows = tablebody!.getElementsByTagName("tr");
    for (let tablerowsKey in tablerows) {
      console.log(tablerowsKey);
    }
    // for (let tablerowsKey in tablerows) {
    //   const tabledeefinition = tablerows[tablerowsKey].getElementsByTagName("td");
    //   console.log(tabledeefinition)
    // }
  }

  public changeArchivedStatus(event: Event, contact: Contact) {

    event.preventDefault()
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    const body = new FormData();

    body.append("uuid", contact.uuid)
    body.append("archived", String(input.checked))

    this.httpClient.patch(RestHelper.API_BASE_URL + 'customer/updateContact', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          input.checked = !input.checked
          contact.archived = input.checked
          if (input.checked && !this.showarchived) {
            input.parentElement?.parentElement?.remove();
          }
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public lastsort: string = ""
  public lastsorttype = ""

  public sortTablebyColum(property: string) {
    let sorttype: string;
    if (this.lastsort === property) {
      if (this.lastsorttype === "ASC") {
        sorttype = "DESC";
      } else {
        sorttype = "ASC"
      }
    } else {
      sorttype = "ASC"
    }
    this.lastsort = property
    this.lastsorttype = sorttype;
    this.getContacts(property, sorttype)
  }

  protected readonly Helper = Helper;
  protected readonly PermissionsHelper = PermissionsHelper;
}
